/* @flow */

import React from 'react';
import Button from './Button';
import Glyph from './Glyph';
import Spinner from './Spinner';

type Props = {
  block?: boolean,
  defaultText?: string,
  disabled?: boolean,
  hasSucceeded?: boolean,
  inProgress?: boolean,
  onClick: Function,
  progressIcon?: Object,
  progressText?: string,
  size: string,
  submit?: boolean,
  successIcon?: mixed,
  successText?: string,
};

const defaultProps = {
  block: false,
  defaultText: undefined,
  disabled: false,
  hasSucceeded: false,
  inProgress: false,
  progressIcon: <Spinner />,
  progressText: undefined,
  submit: false,
  successIcon: <Glyph icon="ios-checkmark-empty" />,
  successText: undefined,
};

function ProgressButton({
  block,
  defaultText,
  disabled,
  hasSucceeded,
  inProgress,
  onClick,
  progressIcon,
  progressText,
  size,
  submit,
  successIcon,
  successText,
}: Props) {
  if (inProgress) {
    return (
      <Button
        block={block}
        onClick={undefined}
        size={size}
        submit={submit}
      >
        <div className="buttonInner">
          {progressIcon}
          <span className="buttonLabel">
            {progressText}
          </span>
        </div>
      </Button>
    );
  }

  if (hasSucceeded) {
    return (
      <Button
        block={block}
        disabled={disabled}
        onClick={undefined}
        size={size}
        submit={submit}
      >
        <div className="buttonInner">
          {successIcon}
          <span className="buttonLabel">
            {successText}
          </span>
        </div>
      </Button>
    );
  }

  return (
    <Button
      block={block}
      disabled={disabled}
      onClick={onClick}
      size={size}
      submit={submit}
      kind="primary"
    >
      {defaultText}
    </Button>
  );
}

ProgressButton.defaultProps = defaultProps;

export default ProgressButton;
